import styled from 'styled-components';

export const PlanWrapper = styled.div`
  background-color: #fff;
  color: #303030;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 1.5rem;

  border-radius: 20px;
  box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.05);
`;

export const PlanName = styled.h4`
  text-align: center;
  font-size: 1.5rem;
`;

export const PlanHours = styled.div`
  margin: 0.4rem 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.2rem;
  color: #808080;
  svg {
    margin-right: 0.5rem;
    display: inline-block;
  }
`;

export const PlanDescription = styled.p`
  text-align: center;
  font-size: 1rem;
  margin-bottom: 0.5rem;
  color: #696969;
`;

export const PlanIcon = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 1rem 0;
`;

export const PlanPrice = styled.div`
  display: flex;
  align-items: center;
  font-size: 0.75rem;
  margin-bottom: 1rem;

  span {
    margin-left: 0.25rem;
    font-size: 1.75rem;
  }
`;

export const PlanButton = styled.a`
  font-size: 1rem;
  text-decoration: none;
  padding: 0.75rem 2rem;
  background-color: #46cc6e;
  border-radius: 0.25rem;
  color: #fff;

  &:hover {
    background-color: #349952;
    color: #fff;
  }
`;
